import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPingupComponent } from './simple-icons-pingup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPingupComponent ],
    exports:      [ SimpleIconsPingupComponent ],
    bootstrap:    []
})
export class SimpleIconsPingupModule {}
